<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col>
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-select
            style="min-width:130px;"
            class="m-1"
            :options="entList"
            v-model="queryParam.buyerTaxCode"
          ></b-form-select>
          <b-form-select
            class="m-1"
            :options="dateRangeList"
            v-model="queryParam.statType"
            placeholder="时间类型"
          ></b-form-select>

          <date-range-picker
            ref="picker"
            opens="center"
            :locale-data="{ locale: daterange.local, format: 'yyyy-MM-dd' ,applyLabel:'确定',cancelLabel:'取消'}"
            :ranges="daterange.ranges"
            v-model="queryParam.daterange"
            style="min-width:200px;"
            placeholder="日期"
            class="m-1"
          ></date-range-picker>

          <b-button variant="outline-primary" @click="query" class="m-1">分析</b-button>
          <b-button class="m-1" variant="primary" to="invoice/olap">多维分析</b-button>
        </b-form>
      </b-col>
    </b-row>

    <!-- 列表1 -->
    <div class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(risk_0)="data">
          <b-link @click="detail(data.item, '0')">{{ data.item.risk_0 }}</b-link>
        </template>

        <template v-slot:cell(risk_1)="data">
          <b-link @click="detail(data.item, '1')">{{ data.item.risk_1 }}</b-link>
        </template>

        <template v-slot:cell(risk_2)="data">
          <b-link @click="detail(data.item, '2')">{{ data.item.risk_2 }}</b-link>
        </template>

        <template v-slot:cell(risk_3)="data">
          <b-link @click="detail(data.item, '3')">{{ data.item.risk_3 }}</b-link>
        </template>

        <template v-slot:cell(risk_4)="data">
          <b-link @click="detail(data.item, '4')">{{ data.item.risk_4 }}</b-link>
        </template>



      </b-table>
    </div>

    <!-- 列表2 -->
    <div class="mt-2">
      <b-table
        id="data-table-2"
        responsive
        hover
        :fields="fields2"
        :items="items2.data"
        :busy="tableLoading2"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
        caption-top
        v-if="showTable2"
      >

        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template #table-caption>{{tableCaption}}</template>

        <template v-slot:cell(invCode)="data">
          {{data.item.invCode+'-'+data.item.invNo}}
        </template>

        <template v-slot:cell(buyerName)="data">
          {{data.item.buyerTaxCode+'-'+data.item.buyerName}}
        </template>

        <template v-slot:cell(fileSubmitter)="data">
          {{data.item.fileSubmitter+'('+data.item.fileSubmitterName+")"}}
        </template>


        <!-- <template v-slot:cell(actions)="data">
          <b-link @click="showUploadFileDialog(data.item)">上传</b-link>
        </template>
 -->
      </b-table>
    </div>
    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam2.page"
        :per-page="queryParam2.size"
        :total-rows="items2.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items2.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>


  </div>
</template>

<script>
import * as invoiceRiskFacade from "../../../api/invoice-risk-facade.js";
import * as orgFacade from "../../../api/org-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import { mapState } from "vuex";

import { zhCN } from "date-fns/locale";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

export default {
  // validations:
  data() {
    return {
      orgList: [
        { text: "机构", value: "" },
        { text: "机构一", value: "1" }
      ],
      dateRangeList: [
        { text: "接收时间", value: "0" },
        { text: "记账时间", value: "1" },
      ],
      entList: [{ text: "受票方", value: "" }],
      
      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      queryParam: {
        orgId: "",
        buyerTaxCode: "",
        statType: "0",
        daterange: {
            startDate: addDays(new Date(), -30),
            endDate: new Date()
          },
        uploadDate:[]
      },

      items:[],
      tableCaption:"",

      // 以上为数据展示和传输对象

      // 以下为页面状态控制参数
      showOrg: false,
      pageLoading: false,
      tableLoading: false,
      tableLoading2: false,
      showTable2: false,
      uploadFileDialogVisible: false,

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      // 以下为表单校验规则

      // 以上为表单校验规则
      fields: [
      {
          key: "buyerTaxCode",
          label: "税号"
        },
        {
          key: "buyerName",
          label: "企业"
        },
        {
          key: "risk_0",
          label: "正常"
        },
        {
          key: "risk_1",
          label: "状态异常"
        },
        {
          key: "risk_2",
          label: "抬头不符"
        },
        {
          key: "risk_3",
          label: "敏感词"
        },
        {
          key: "risk_4",
          label: "黑名单"
        },
      ],

      fields2: [
      {
          key: "invCode",
          label: "发票代码-号码"
        },
        {
          key: "sellerName",
          label: "开票方"
        },
        {
          key: "buyerName",
          label: "受票方"
        },
        {
          key: "issueDate",
          label: "开票日期"
        },
        {
          key: "totalAmount",
          label: "金额"
        },
        {
          key: "fileSubmitter",
          label: "提交人"
        },
        {
          key: "uploadTime",
          label: "提交时间"
        },
        {
          key: "riskMsg",
          label: "风险原因",
        },
        {
          key: "status",
          label: "发票状态",
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 分页查询的参数
      items2: {
        totalElements: 0,
        data: []
      },
      queryParam2: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          buyerTaxCode: "",
          statType: "",
          uploadDate: [],
          dateRange: {},
          riskCode:"",
          entIds:""
        },
        sortOrder: { createTime: "descending" }
      },


    };
  },
  watch: {
    "queryParam.orgId"() {
      if (this.queryParam.orgId) {
        entFacade
          .findByOrgId(this.queryParam.orgId)
          .then(res => {
            this.parseEntInfo(res);
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });
      }
    }
  },

  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    this.initInfo();
  },
  mounted() {
    // 异步加载列表数据
    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    // 根据查询条件检索数据
    query(){

      this.showTable2=false
      this.tableLoading = true; // 打开表格的Loading状态

      if (this.queryParam.daterange) {
        this.queryParam.uploadDate[0] = addHours(
          this.queryParam.daterange.startDate,
          8
        );
        this.queryParam.uploadDate[1] = addHours(
          this.queryParam.daterange.endDate,
          8
        );
      }
      invoiceRiskFacade
        .ayalysis(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
          if(res.length==0){
            this.$message({
              message: "没有检索到发票信息",
              type: "danger"
            });

          }
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    list(page){
      if (page) {
        this.queryParam2.page = page;
      }

      invoiceRiskFacade
        .pageList(this.queryParam2) // 异步调用后台接口
        .then(res => {
          this.items2 = res; // 为表格填充数据
          this.tableLoading2 = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading2 = false;
        });

    },

    detail(dataItem, riskCode){
      this.tableLoading2 = true; // 打开表格的Loading状态
      this.queryParam2.criteria = this.queryParam;
      this.queryParam2.criteria.riskCode = riskCode;
      this.queryParam2.criteria.buyerTaxCode = dataItem.buyerTaxCode
      this.tableCaption = dataItem.buyerName;
      this.showTable2=true

      this.list(1)
    },



    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];

          res.map(item => {
            let org = {};
            org.text = item.name;
            org.value = item.id;
            orgList.push(org);
          });
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //获取企业信息
    async getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUser()
        .then(res => {
          this.parseEntInfo(res);
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //初始化信息
    initInfo() {
      let roles = this.info.roles;
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        this.showOrg = true;
        this.getOrgInfo();
        this.getEntInfo();
      } else {
        //机构管理员或者财务经理
        this.showOrg = false;
        this.getEntInfo();
      }

      // 设置月份
      const currentDate = new Date();
      const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
      this.queryParam.month = lastMonth.getFullYear() +""+ ((lastMonth.getMonth() + 1) > 9 ? (lastMonth.getMonth() + 1) : "0" + (lastMonth.getMonth() + 1));

    },
    //解析企业信息
    parseEntInfo(res) {
      this.pageLoading = false;
      let entList = [{ text: "受票方", value: "" }];
      let accEntList = [];
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          entList.push(ent);
          accEntList.push(ent);
        });
      }

      this.entList = entList;
      this.accEntList = accEntList;
      if (this.accEntList.length > 0) {
        this.accountParam.entCode = this.accEntList[0].value;
      }
    },

    //查看发票
    handleView(item) {
      if(item.fileFormat == null){
        const { href } = this.$router.resolve({
          name: "view",
          query: { c: item.id }
        });

        window.open(href, "_blank");

      }else{
        const { href } = this.$router.resolve({
          name: "viewer2",
          query: { id: item.id }
        });

        window.open(href, "_blank");
      }
    },

  },


};

</script>